import { SVGProps } from "react";

export default function CloseCross(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width || "36"}
      height={props.height || "36"}
      viewBox="0 0 16 16"
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="close-fill">
        <path
          id="Vector"
          d="M8.00004 7.14969L10.97 4.17969L11.8184 5.02809L8.84844 7.99809L11.8184 10.9681L10.97 11.8165L8.00004 8.84649L5.03004 11.8165L4.18164 10.9681L7.15164 7.99809L4.18164 5.02809L5.03004 4.17969L8.00004 7.14969Z"
          className={props.className}
        />
      </g>
    </svg>
  );
}
